































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Input from '@shared/components/forms/inputs/input/input.vue';

@Component({
  name: 'bpc-replace-access-control-badge-modal',
  components: {
    'bpc-input': Input,
  },
})
export default class ReplaceAccessControlBadgeModal extends Vue {
  // PROPS
  @Prop({ type: String, default: 'replace-access-control-badge-modal' })
  readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Number, default: 0 }) readonly AccessControlBadgeId: number;
  public newBadgeReference: string = '';
  public replacementLoading: boolean = false;

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // LIFECYCLE
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  // METHODS
  closeModal() {
    this.$emit('close-modal');
  }

  resetModal() {
    this.newBadgeReference = '';
    this.replacementLoading = false;
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  onConfirm() {
    this.replacementLoading = true;
    this.replaceBadge(this.newBadgeReference);
  }

  replaceBadge(newBadgeReference) {
    const path = `${this.$bpcApiRouteHelper.getEntityPath('access-control-badges')}/${
      this.AccessControlBadgeId
    }/replace-badge`;

    const payload: AnyEntity = {
      new_badge_reference: newBadgeReference,
    };

    this.$bpcApi.post(path, payload).subscribe(
      () => {
        this.replacementLoading = false;
        this.$emit('badge-replaced');
      },
      error => {
        this.replacementLoading = false;
      },
    );
  }

  // WATCHERS
  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.resetModal();
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
